import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-service-qr-code-view',
    templateUrl: './service-qr-code-view.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServiceQrCodeViewComponent implements OnInit {

    readonly QrCodeAccessType = QrCodeAccessType;

    @Input() qrRawData!: string;
    @Input() qrName!: string;
    @Input() serviceId!: string;

    public qrData: string = '';

    selectedAccess: QrCodeAccessType = QrCodeAccessType.Public;

    constructor(
        public activeModal: NgbActiveModal,
        public readonly translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.updateQrCodeData();
    }

    selectAccess(access: QrCodeAccessType) {
        this.selectedAccess = access;
        this.updateQrCodeData();
    }

    private updateQrCodeData() {
        if (this.selectedAccess === QrCodeAccessType.Public) {
            this.qrData = window.location.origin + '/#/services/' + this.serviceId + '/activate/' + this.qrRawData;
        } else {
            this.qrData = this.serviceId + '/activate/' + this.qrRawData;
        }
    }
}

enum QrCodeAccessType {
    Private = 'Private',
    Public = 'Public'
}
